var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.687,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#7AB8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.585 11.351c.22.22.22.576 0 .796l-7.875 7.875a.562.562 0 01-.795 0l-3.938-3.938a.563.563 0 01.796-.795l3.54 3.54 7.477-7.478c.22-.22.576-.22.795 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzMCAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC42ODY3NjgiIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgcng9IjE1IiBmaWxsPSIjN0FCOEZGIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEuNTg1MiAxMS4zNTE1QzIxLjgwNDkgMTEuNTcxMiAyMS44MDQ5IDExLjkyNzMgMjEuNTg1MiAxMi4xNDdMMTMuNzEwMiAyMC4wMjJDMTMuNDkwNiAyMC4yNDE3IDEzLjEzNDQgMjAuMjQxNyAxMi45MTQ4IDIwLjAyMkw4Ljk3NzI1IDE2LjA4NDVDOC43NTc1OCAxNS44NjQ4IDguNzU3NTggMTUuNTA4NyA4Ljk3NzI1IDE1LjI4OUM5LjE5NjkyIDE1LjA2OTQgOS41NTMwOCAxNS4wNjk0IDkuNzcyNzUgMTUuMjg5TDEzLjMxMjUgMTguODI4OEwyMC43ODk4IDExLjM1MTVDMjEuMDA5NCAxMS4xMzE5IDIxLjM2NTYgMTEuMTMxOSAyMS41ODUyIDExLjM1MTVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgCheckBlue as ReactComponent };